const listingIdMinChId = 4000000000000;
const sectionIdMinChId = 100000000;
/**
 * return true when val is set and not an empty string
 **/
export const isSet = val => (val !== undefined && val !== "undefined" && val !== null && val !== '' && val !== 'null');

export const isNotEmpty = variable => isSet(variable) && variable !== ''

export const isAnyEntryEmpty = arrayValues => {
    if (!Array.isArray(arrayValues)) {
        throw new TypeError('Expected an array');
    }
    return arrayValues.some(isEmpty);
}
/**
 * return true when listingId is a ch id
 **/
export const isChListing = (listingId) => (parseInt(listingId, 10) >= listingIdMinChId);

/**
 * return true when sectionId is a ch id
 **/
export const isChSection = (sectionId) => (sectionId >= sectionIdMinChId);

/**
 * return true when val is not set or empty array
 **/
export const isEmpty = val => (!isSet(val) || val.length < 1);

/**
 * @returns {number} second since 1 jan 70
 */
export const nowSec = () => Math.floor(Date.now() / 1000)
